import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { currencyFormatter } from "../../pickup/pickup-detail/pickup-detail-table/column-formatters";

export default function ImportMutationBankTable({ dataTable }) {
  const columns = [
    {
      dataField: "trx_date",
      text: "Tanggal",
      sort: true,
      // sortCaret: sortCaret,
    },
    {
      dataField: "message",
      text: "Deskripsi",
      sort: true,
      // sortCaret: sortCaret,
    },
    {
      dataField: "amount",
      text: "Amount",
      sort: true,
      classes: "text-right",
      headerClasses: "text-right",
      // sortCaret: sortCaret,
      formatter: (cell) => {
        return currencyFormatter(cell);
      },
    },
  ];
  return (
    <>
      <BootstrapTable
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden"
        bootstrap4
        bordered={false}
        remote
        keyField="uuid"
        data={dataTable === null ? [] : dataTable}
        columns={columns}
      />
    </>
  );
}
